document.addEventListener('DOMContentLoaded', () => {
  const animateOnScroll = () => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ua-animate-in');
          observer.unobserve(entry.target); 
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.15 
    });

    const wrappers = document.querySelectorAll('.ua-iwt-pro-wrapper');
    wrappers.forEach(wrapper => {
      observer.observe(wrapper);
    });
  };

  // Run on initial load
  animateOnScroll();

  // Re-initialize for Shopify Theme Editor compatibility
  document.addEventListener('shopify:section:load', animateOnScroll);
});